// services/entitlement/useEntitlements.ts
import { useEffect, useMemo, useState } from "react";
import type { ResourcePermission } from "../../utils/entitlements";
import { fetchEntitlements } from "./api";
import { getCurrentUserKinshipId } from "../../utils/apis";

const ALL_RESOURCES: ResourcePermission[] = [
  "ai:ask",
  "immediate_rc:apply",
  "rc:patch",
  "create_practice_tool:get",
  "create_practice_tool:patch",
  "create_practice_tool:post",
  "create_practice_tool:delete",
];

export function useEntitlements() {
  const role = "theWildestAdmin";
  const action = "access_web_admin_console_api";
  const [loaded, setLoaded] = useState(false);
  const [permissions, setPermissions] = useState<Set<ResourcePermission>>(
    new Set(),
  );
  const principalId = getCurrentUserKinshipId();
  useEffect(() => {
    if (!principalId) {
      setLoaded(true);
      setPermissions(new Set());
      return;
    }

    let cancelled = false;

    (async () => {
      setLoaded(false);

      try {
        const allowed = await fetchEntitlements({
          principal: { id: principalId },
          action,
          role,
          resources: ALL_RESOURCES,
        });

        if (cancelled) return;

        const permissionSet = new Set(allowed);
        console.log(Array.from(permissionSet));

        setPermissions(permissionSet);
        setLoaded(true);
      } catch (e) {
        if (cancelled) return;

        setPermissions(new Set());
        setLoaded(true);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [principalId, role, action]);

  return useMemo(() => {
    return {
      loaded,
      permissions,
      can: (p: ResourcePermission) => permissions.has(p),
    };
  }, [loaded, permissions]);
}
